export type CMSUILanguage = "en" | "es" | "pl";

export const LANGUAGE_DTO_MAP: Record<string, string> = {
  "0": "en",
  "1": "pl",
  "2": "de",
  "3": "fr",
  "4": "cz",
  "5": "uk",
  "6": "es",
  "7": "pt",
  "8": "it",
};

export function languageDtoToCode(dto: string): string {
  if (LANGUAGE_DTO_MAP[dto]) {
    return LANGUAGE_DTO_MAP[dto];
  }
  const validCodes = Object.values(LANGUAGE_DTO_MAP);
  if (validCodes.includes(dto)) {
    return dto;
  }
  return "en";
}

export interface CMSQueryParams {
  language: CMSUILanguage;
  contestId: string | null;
  editionId: string | null;
  targetLanguage: string;
  pageId: string | null;
}

export type CMSIncomingMessage =
  | { action: "change-language"; data: { language: CMSUILanguage } }
  | { action: "get-generated-html"; data: { requestId: string } }
  | { action: "set-initial-content"; data: { html: string } };

export type CMSOutgoingMessage =
  | { action: "generated-html"; data: { requestId: string; html: string } }
  | { action: "set-dirty"; data: { dirty: boolean } }
  | { action: "ready" };

export interface CMSState {
  uiLanguage: CMSUILanguage;
  targetLanguage: string;
  contestId: string | null;
  editionId: string | null;
  isEmbedded: boolean;
  isDirty: boolean;
}

const PRODUCTION_CMS_ORIGINS = [
  "https://activy.app",
  "https://staging.activy.app",
  "https://app.activy.app",
  "https://test.activy.app",
  "https://cms.local.lncd.pl",
  "https://cms.activy.lncd.pl",
  "https://cms-v2.activy.lncd.pl",
  "https://cms-v2.v3.activy.pl",
  "https://cms.v3.activy.pl",
  "https://cms-v2.v3.activy.app",
  "https://cms.v3.activy.app",
  "https://platform.activy.app",
];

function getAllowedOrigins(): Set<string> {
  const origins = new Set(PRODUCTION_CMS_ORIGINS);

  const additionalOrigins = import.meta.env.VITE_CMS_ALLOWED_ORIGINS;
  if (additionalOrigins) {
    additionalOrigins.split(",").forEach((origin: string) => {
      const trimmed = origin.trim();
      if (trimmed) {
        origins.add(trimmed);
      }
    });
  }

  return origins;
}

export const CMS_ORIGINS = getAllowedOrigins();
